import { render, staticRenderFns } from "./CustomSchedule.vue?vue&type=template&id=08d1bf1a&scoped=true"
import script from "./CustomSchedule.vue?vue&type=script&lang=js"
export * from "./CustomSchedule.vue?vue&type=script&lang=js"
import style0 from "./CustomSchedule.vue?vue&type=style&index=0&id=08d1bf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1bf1a",
  null
  
)

export default component.exports